<template>
    <div>
        <list-vue
            v-bind:busqueda="busqueda"
            v-bind:busquedaTraduccion="busquedaTraduccion"
            v-bind:busquedaMedidas="busquedaMedidas"
            v-bind:opciones="opciones"
            v-bind:moduloTitulo="moduloTitulo"
            v-bind:pantallaTitulo="pantallaTitulo"
            v-bind:rutaConsulta="rutaConsulta"
            v-bind:buttonsPage="buttonsPage"
            v-bind:busquedaCampos="busquedaCampos"
            v-bind:permisos="permisos"
        ></list-vue>
    </div>
</template>
<script type="text/javascript">
export default {
    data() {
        return {
            permisos: {},
            //Definimos los nombres generales
            moduloTitulo: "Configuraciones | Numeración",
            reporte: false,
            pantallaTitulo: this.$root.trans("Resultado"),
            rutaConsulta: this.$route.fullPath,
            buttonsPage: [
                {
                    type: "button",
                    path: true,
                    class: "btn btn-xs btn-info ",
                    route: "/sistema/public/configuraciones/numeracion/new",
                    text: "+",
                    name: "sel",
                    description: '<i class="fa fa-plus">',
                },
            ],
            //Definimos los campos de busqueda, sus nombres e incluso tamaño
            busqueda: {
                codigo: "",
                descripcion: "",
                estado: "",
            },
            busquedaTraduccion: {
                codigo: this.$root.trans("Cod."),
                descripcion: this.$root.trans("Descripcion"),
                estado: this.$root.trans("Estado"),
            },
            busquedaCampos: {
                estado: {
                    type: "select",
                    options: [
                        { label: "Activo", code: "A" },
                        { label: "Dado de baja", code: "B" },
                    ],
                },
            },
            busquedaMedidas: {
                codigo: "80px",
            },
            //definimos las opciones con enlace simple para ello usamos el nombre de la ruta y en caso de eliminar usamos la ruta
            opciones: [],
        };
    },
    methods: {},
    mounted() {},
    created() {

    },
};
</script>
